module.exports = __webpack_public_path__ + "static/media/bicoNylon90.214227ec.png";